import Browse from "@/api/browse/Browse";
import analysis_tf from "@/api/analysis/tf"
import analysis2 from "@/api/analysis/analysis2"
import analysis3 from "@/api/analysis/analysis3"
import Detail from "@/api/detail/detail"
import Search from "@/api/search/search"
export default {
  Browse,analysis_tf,analysis2,Detail,analysis3,Search
}
